module.exports = __webpack_public_path__ + "static/media/Screenshot_1-thumb.edd82a7a.png";